export const Options = {
    body: {
        lat: [],
        lon: [],
        rain: [],
        obsTime: [],
        station: [],
        sunshine: [],
        elevation: [],
        lowTemperature: [],
        highTemperature: []
    },
    views: {
        avgTemperature(self) {
            return (self.lowTemperature + self.highTemperature) / 2;
        }
    }
};
